import React, { useState, useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2'
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';
import { useParams } from "react-router-dom";
import ReactPlayer from 'react-player'
import "./DynamicSentence.css";
import './matchcss.css';

const Sentence = (props) => {
    const { t } = useTranslation()
    const [hasMediaContent, sethasMediaContent] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [parts, setParts] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [obj, setObj] = useState([]);
    const [answ, setAnsw] = useState([]);
    const [url, setUrl] = useState([]);
    const [ans, setAns] = useState([]);
    const [sentenceText, setSentenceText] = useState("");
    const [sentenceAnswers, setSentenceAnswers] = useState([]);
    const { user } = useAuth();
    const params = useParams();
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [subjectName, setSubjectName] = useState("");
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;

    const getSubject = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {
                if (res.data['success']) {
                    setSubjectName(res.data['data']['subjects'][params['subjectid'] - 1]['subjectName'] + " - " + res.data['data']['subjects'][params['subjectid'] - 1]['subjectDesc'])
                }
            });
        } catch (err) {
            console.log();
        }
    };
    const getDynamicPadding = () => {
        const ratio = imageDimensions.width / imageDimensions.height;
        if (ratio > 1) {
            // Yatay (16:9 gibi)
            return { paddingTop: "10px", paddingBottom: "10px" };
        } else if (ratio < 1) {
            // Dikey (9:16 gibi)
            return { paddingLeft: "10px", paddingRight: "10px" };
        }
        return {}; // Kare resimler için padding yok
    };

    // Medya türü kontrolü yaparak boş kutuyu engelle

    const Request = async (userAnswer) => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/user/Content/Answer";
            await axios({
                method: 'GET',
                url: url,
                params: {
                    questionId: props.questionNumber,
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);

                if (res.data['success']) {
                    let audio = new Audio("https://api.heryerdeingilizce.com/sound/d6350096-7457-46bc-bcaa-313a33970558.mp4");
                    audio.play();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                    });
                }
                else {
                    if (res.data['alertType'] === "question") {
                        let audio = new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4");
                        audio.play();
                        Swal.fire({
                            title: "Hatalı cevap",
                            text: "Doğru Cevap: " + res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                    else {
                        let errorMsg = res['data']['message'];
                        let audio = new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4");
                        audio.play();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        }
        catch (err) {
            console.log(err.message);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);

        const selectedIndexes = [];

        for (let [key, value] of formData.entries()) {
            if (key.startsWith("blank_")) {
                selectedIndexes.push(value);
            }
        }

        const result = selectedIndexes.join(",");
        const attempt = parseInt(localStorage.getItem(ATTEMPT_KEY));
        const correctAnswer = props.data.answer;
        //1. DENEME
        if (attempt === 0) {
            if (result === correctAnswer) {
                Request(result);
            } else {
                localStorage.setItem(ATTEMPT_KEY, "1");

                new Audio(
                    "https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4"
                ).play();

                Swal.fire({
                    title: "Tekrar Deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }

        // 2. DENEME → DİREKT BACKEND
        Request(result);




    };

    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }

        return () => {
            localStorage.removeItem(ATTEMPT_KEY);
        };
    }, [ATTEMPT_KEY]);
    useEffect(() => {
        getSubject();

        setObj(JSON.parse(props.data.contentStr))
        var question = JSON.parse(props.data.contentStr)['text']
        var questionn = JSON.parse(props.data.contentStr);
        var questionTitlee = questionn['text'].split('__')[0];
        let questionTextt = questionn['text'].split('__')[1];
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
        if (obj['type'] === "sound" || obj['type'] === "video" || obj['type'] === "image") {
            sethasMediaContent(true)
        }
        else {
            sethasMediaContent(false)

        }

        let ans = JSON.parse(props.data.detail);

        setAnsw(JSON.parse(props.data.detail));
        setUrl(JSON.parse(props.data.contentStr)['url']);
        setAns(ans);
        setParts(parts);
        setSentenceText(questionTextt);
        setSentenceAnswers(ans);
        setParts(questionTextt.split("_"));
    }, []);
    return (
        <div>
            <span style={{ color: "black" }}> <b><i>{subjectName}</i></b></span>
            <br />
            <div style={{ alignItems: "center", textAlign: "center" }}>
                {obj['type'] === "sound" ? (
                    <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",  // sadece medya varsa flex, yoksa block
                        width: "100%",
                        maxWidth: "500px",
                        margin: "0 auto",
                        overflow: "hidden",
                        padding: "10px"
                    }}>
                        <div style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "500px"
                        }}>
                            <ReactAudioPlayer
                                src={url}
                                autoPlay={false}
                                controls={true}
                                controlsList="nodownload "

                            />
                        </div>

                    </div>

                ) : (
                    <div></div>
                )}
                {obj['type'] === "video" ? (
                    <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",  // sadece medya varsa flex, yoksa block
                        width: "100%",
                        maxWidth: "500px",
                        margin: "0 auto",
                        overflow: "hidden",
                        padding: "10px"
                    }}>
                        <div style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "500px",
                            minHeight: "300px"

                        }}>
                            <ReactPlayer
                                className='react-player'
                                width="100%"
                                height="300px"
                                url={url}
                                controls={true}
                            />
                        </div>

                    </div>

                ) : (
                    <div></div>
                )}
                {obj['type'] === "image" ? (
                    <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",  // sadece medya varsa flex, yoksa block
                        width: "auto",
                        maxWidth: "auto",
                        margin: "0 auto",
                        overflow: "hidden",
                        padding: "10px"
                    }}>
                        <div style={{
                            width: "auto",
                            height: "auto",
                            margin: "0 auto",
                            overflow: "hidden",
                            ...getDynamicPadding()  // Dinamik padding uygula
                        }}>
                            <img
                                src={url}
                                alt="Question Media"
                                style={{
                                    width: "80%",
                                    height: "100%",
                                    maxHeight: "250px",
                                    objectFit: "contain", // Resmi kutuya sığdırırken oranlarını korur
                                    borderRadius: "10px", // Opsiyonel, görseli daha hoş göstermek için
                                }}
                            />

                        </div>

                    </div>

                ) : (
                    <div></div>
                )}

                <b style={{ fontSize: "18px", fontFamily: 'calibri', color: "SteelBlue" }}>
                    {questionTitle}
                </b>

                <br /><br />
            </div>

            <div className="d-flex justify-content-center" style={{ fontSize: 40 }}>
                <form onSubmit={handleSubmit}>
                    <div style={{ fontSize: "18px", lineHeight: "2" }}>
                        {parts.map((part, index) => (
                            <React.Fragment key={index}>
                                <span style={{ fontSize: "22px" }}>{part}</span>

                                {index < parts.length - 1 && sentenceAnswers[index] && (
                                    <select
                                        name={`blank_${index}`}
                                        className="dynamic-select"
                                        data-blank-index={index}
                                        required
                                    >
                                        <option value="" disabled hidden>
                                            Seçim yapınız
                                        </option>

                                        {sentenceAnswers[index].service.map((opt, i) => (
                                            <option key={i} value={i + 1}>
                                                {opt}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </React.Fragment>
                        ))}

                    </div>

                    <br />
                    {props.answered ? (
                        <b style={{ fontSize: "15px" }}> cevaplanmış <i>{props.realanswer}</i> </b>
                    ) : (
                        <div className='d-flex justify-content-center'>
                            <button type="submit" className="save-btn">{t("saveAndContinue")}</button>
                        </div>
                    )}
                </form>




            </div>

        </div>
    );
};

export default Sentence;
